import { COOKIE_CONSENT_KEY } from "./firebase";

const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID?.trim();
const META_PIXEL_SCRIPT_ID = "meta-pixel-script";

let initialized = false;
let lastTrackedLocation = null;

const analyticsAllowed = () => {
  try {
    return window.localStorage.getItem(COOKIE_CONSENT_KEY) === "analytics";
  } catch (error) {
    return false;
  }
};

const installPixelQueue = () => {
  if (window.fbq) return;

  const fbq = function (...args) {
    fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args);
  };

  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;
};

const loadPixelScript = () => {
  if (document.getElementById(META_PIXEL_SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = META_PIXEL_SCRIPT_ID;
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
};

export const initializeMetaPixel = () => {
  if (!META_PIXEL_ID || !analyticsAllowed()) return false;

  installPixelQueue();
  loadPixelScript();

  if (!initialized) {
    window.fbq("init", META_PIXEL_ID);
    initialized = true;
  }

  window.fbq("consent", "grant");
  return true;
};

export const setMetaPixelConsent = (allowed) => {
  if (allowed) {
    initializeMetaPixel();
    return;
  }

  if (window.fbq) {
    window.fbq("consent", "revoke");
  }
  lastTrackedLocation = null;
};

export const trackMetaEvent = (eventName, parameters = {}) => {
  if (!eventName || !initializeMetaPixel()) return false;

  window.fbq("track", eventName, parameters);
  return true;
};

export const trackMetaPageView = (location) => {
  if (!location || location === lastTrackedLocation) return false;
  if (!trackMetaEvent("PageView")) return false;

  lastTrackedLocation = location;
  return true;
};

